import { IconButton } from '@launchpad-ui/components';

import styles from './RemovableSettingSection.module.css';

/**
 * An optional metric setting once it has been added: a titled section, divided from what
 * precedes it by a hairline spanning the enclosing card, with an X that removes it.
 */
export const RemovableSettingSection: React.FC<{
  title: string;
  /** Doubles as the remove button's accessible name, so it reads as a complete action. */
  removeLabel: string;
  onRemove: () => void;
  children: React.ReactNode;
}> = ({ title, removeLabel, onRemove, children }) => (
  <section className={styles.removableSettingSection}>
    <div className={styles.header}>
      <span className={styles.title}>{title}</span>
      <IconButton icon="cancel" size="small" variant="minimal" aria-label={removeLabel} onPress={onRemove} />
    </div>
    {children}
  </section>
);
